export const billing = {
aiUsageAudit: {
title: "KI- und Automatisierungsprotokoll des Workspace",
loading: "Prüfprotokoll wird geladen...",
empty: "Noch keine Protokollereignisse.",
intro: "Prüfpfad der KI- und Automatisierungs-Hooks für diesen Workspace. Zeigt die letzten 200 Ereignisse mit Funktion, Trace-, Nutzungs- und Credit-Metadaten, sofern verfügbar.",
refresh: "Aktualisieren",
refreshing: "Wird aktualisiert...",
noAccount: "Für dieses Profil wurde kein Workspace-Konto gefunden.",
loadFailed: "Protokollereignisse konnten nicht geladen werden.",
service: "Dienst:",
status: "Status:",
filters: {
all: "Alle",
success: "Erfolgreich",
error: "Fehler",
ai: "KI",
automation: "Automatisierung",
},
totalCredits: "KI-Credits gesamt (gefiltert):",
totalShown: "Angezeigt gesamt:",
creditUnitsLogged: "Erfasste Credit-Einheiten (KI + Automatisierung, angezeigte Ereignisse):",
noEventsFiltered: "Für die ausgewählten Filter wurden keine Ereignisse gefunden.",
memberTitle: "KI-Nutzung",
memberSubtitle: "Alle im Workspace teilen sich die KI-Credits.",
memberBody: "Die KI-Nutzung dieses Workspace prüft sein Inhaber. Das gemeinsame Credit-Guthaben finden Sie unter Abrechnung & Nutzung.",
},
usage: {
addons: {
  title: "Zusatzmodule",
  subtitle: "Zusatzfunktionen für Ihren Plan, pro Anlage berechnet.",
  loadFailed: "Add-ons konnten nicht geladen werden. Versuchen Sie es später erneut.",
  perAssetMonth: "{{price}} pro Anlage und Monat",
  included: "In Ihrem Plan enthalten",
  statusTrialing: "An: kostenlose Testphase bis {{date}}",
  statusActive_one: "An für {{count}} Anlage: {{total}} pro Monat",
  statusActive_other: "An für {{count}} Anlagen: {{total}} pro Monat",
  statusActiveNoPrice_one: "An für {{count}} Anlage",
  statusActiveNoPrice_other: "An für {{count}} Anlagen",
  statusOff: "Aus",
  notOnPlan: "Nicht in Ihrem Plan. Wechseln Sie den Plan, um es hinzuzufügen (unter Pläne sehen Sie, welche es anbieten).",
  notAvailableInApp: "In der App nicht käuflich",
  adminsOnly: "Workspace-Admins fügen Add-ons hinzu oder schalten sie aus.",
  coverTitle: "Was es abdeckt",
  coverWhole: "Ganzer Workspace",
  coverSites: "Ausgewählte Standorte",
  coverHint: "Ein ausgewählter Standort deckt auch die Standorte darin ab.",
  noSites: "Noch keine Standorte: es deckt den ganzen Workspace ab.",
  liveTotal_one: "{{count}} Anlage × {{price}} = {{total}} pro Monat",
  liveTotal_other: "{{count}} Anlagen × {{price}} = {{total}} pro Monat",
  trialNote: "{{days}} Tage kostenlos, danach mit Ihrem Plan abgerechnet. Jederzeit abschaltbar.",
  proRata: "Änderungen gelten ab heute und werden anteilig auf Ihrer nächsten Rechnung berechnet oder gutgeschrieben.",
  startTrial: "{{days}} Tage kostenlos testen",
  startPaid: "Zu meinem Plan hinzufügen",
  save: "Abdeckung speichern",
  end: "Ausschalten",
  keep: "Behalten",
  endConfirmTitle: "{{name}} ausschalten?",
  endConfirmBody: "Es endet heute; ungenutzte bezahlte Zeit wird auf Ihrer nächsten Rechnung gutgeschrieben. Ihre ESG-Daten bleiben erhalten und sind beim erneuten Einschalten wieder da.",
  chooseSite: "Wählen Sie mindestens einen Standort oder den ganzen Workspace.",
  failed: "Das Add-on konnte nicht geändert werden. Versuchen Sie es erneut.",
},
  assistantGate: {
    debitFailedMember: "Der Assistent konnte für diese Anfrage keine Credits verwenden. Versuchen Sie es gleich erneut.",
    debitFailedAdmin: "Der Assistent konnte für diese Anfrage keine Credits verwenden. Versuchen Sie es erneut oder prüfen Sie Abrechnung & Nutzung, wenn es weiter passiert.",
    debitFailedTitle: "Credits konnten nicht verwendet werden",
    disabledAdmin: "KI ist im Plan dieses Workspace nicht enthalten. Öffnen Sie Abrechnung & Nutzung, um Pläne mit KI zu sehen.",
    disabledMemberUnnamed: "KI ist im Plan dieses Workspace nicht enthalten. Sprechen Sie den Workspace-Inhaber auf den Plan an.",
    disabledMember: "KI ist im Plan dieses Workspace nicht enthalten. Sprechen Sie {{owner}} auf den Plan an.",
    disabledTitle: "Der KI-Assistent ist aus",
  },
  assetGate: {
    seePlans: "Pläne ansehen",
    subscriptionRequired: "Ihr Workspace hat die kostenlosen Anlagen seines Plans aufgebraucht. Starten Sie ein Abo, um weitere Anlagen hinzuzufügen.",
    askOwner: "Bitten Sie den Workspace-Inhaber, einen Plan hinzuzufügen, bevor weitere Anlagen hinzugefügt werden können.",
    askOwnerNamed: "Bitten Sie den Inhaber von {{workspace}}, einen Plan hinzuzufügen, bevor weitere Anlagen hinzugefügt werden können.",
    title: "Abo erforderlich",
  },
  checkout: {
    unavailable: "Kaufen ist gerade nicht möglich. Versuchen Sie es später erneut.",
    needsEmail: "Fügen Sie Ihrem Profil eine E-Mail-Adresse hinzu, bevor Sie zur Zahlung gehen.",
    contactSales: "Dieser Plan wird über unser Team verkauft. Kontaktieren Sie AssetWRX, um zu starten.",
    notConfigured: "Dieser Plan kann noch nicht gekauft werden. Wenden Sie sich an den Support.",
    generic: "Die Zahlung konnte nicht gestartet werden. Versuchen Sie es gleich erneut oder wenden Sie sich an den Support, wenn es weiter passiert.",
  },
  store: {
    planGone: "Dieser Plan wird nicht mehr angeboten. Schließen Sie diesen Bildschirm und öffnen Sie ihn erneut.",
    unavailable: "Store-Käufe sind in dieser App-Version nicht verfügbar.",
    purchaseFailed: "Der Kauf ist nicht durchgegangen. Versuchen Sie es erneut.",
    ownerOnly: "Nur der Workspace-Inhaber kann das Store-Abo verwalten.",
  },
  workAi: {
    hostFallback: "der Arbeitsbereich",
    settingTitle: "KI für Personen, mit denen Sie arbeiten",
    settingSubtitle: "Auftragnehmer und Anfragende können KI bei Ihren Aufträgen, Prüfungen und Anlagen nutzen, bezahlt aus Ihren Guthaben.",
    settingLabel: "Guthaben pro Monat und Person",
    settingHelper: "Leer lassen für das Standardkontingent. 0 schaltet es ab.",
    settingPlaceholder: "Standardkontingent",
    settingInvalid: "Geben Sie eine ganze Zahl ein oder lassen Sie das Feld leer.",
    settingSave: "Speichern",
    settingSaved: "Gespeichert",
    settingFailed: "Das Kontingent konnte nicht gespeichert werden",
    usedTitle: "Die KI von {{host}} ist für diesen Monat aufgebraucht",
    offTitle: "{{host}} stellt für seine Arbeit keine KI bereit",
    useOwnBody: "Sie können stattdessen Ihre eigenen KI-Guthaben verwenden.",
    notNow: "Nicht jetzt",
    useOwn: "Meine Guthaben verwenden",
    refused: "Die KI von {{host}} ist für diesen Monat aufgebraucht.",
  },
  aiGate: {
    freePeriodEnded: "KI ist pausiert, weil die kostenlose Zeit abgelaufen und dieser Workspace schreibgeschützt ist.",
    pastDue: "KI ist wegen eines Zahlungsfehlers pausiert. Aktualisieren Sie die Abrechnung, um sie wieder einzuschalten.",
    canceled: "KI ist aus, weil das Abo dieses Workspace gekündigt wurde.",
    notEnoughCredits_other: "Dafür sind {{count}} KI-Credits nötig, und Ihr Workspace hat nicht genug.",
    notEnoughCredits_one: "Dafür ist {{count}} KI-Credit nötig, und Ihr Workspace hat nicht genug.",
    readOnly: "KI ist pausiert, weil dieser Workspace schreibgeschützt ist.",
    notInPlan: "KI ist im Plan dieses Workspace nicht enthalten.",
    checkFailed: "Ihre KI-Credits konnten nicht geprüft werden. Versuchen Sie es erneut.",
  },
  creditCode: {
    refund: "Erstattung",
    adjustment: "Korrektur",
    included: "Enthaltene Credits",
    purchase: "Kauf",
    topUp: "Aufladung",
    aiCredits: "KI-Credits",
    aiUsage: "KI-Nutzung",
  },
  packCredits_other: "{{count}} Credits",
  packCredits_one: "{{count}} Credit",
  planLoadFailed: "Ihr Plan konnte nicht geladen werden.",
  ownerManagesUnnamed: "Der Workspace-Inhaber verwaltet Plan und Credits dieses Workspace.",
  ownerManages: "{{owner}} verwaltet Plan und Credits dieses Workspace.",
  confirmationAwaitingBody: "Schließen Sie die Zahlung im Zahlungsfenster ab und kommen Sie dann hierher zurück. Tippen Sie auf Aktualisieren, falls Plan und Credits nicht aktualisiert sind.",
  confirmationAwaitingTitle: "Warten auf Ihre Zahlung",
  paymentStatusInactiveDetailMember: "Es gibt kein aktives Abo. Der Workspace-Inhaber kann eines starten.",
  paymentStatusPausedDetailMember: "Das Abo ist pausiert. Der Workspace-Inhaber kann es fortsetzen.",
  paymentStatusPastDueDetailMember: "Eine Zahlung ist überfällig. Der Workspace-Inhaber kann das unter Abrechnung & Nutzung beheben.",
  statusFreePeriodEndedMember: "Die kostenlose Zeit ist abgelaufen und der Workspace ist schreibgeschützt. Der Inhaber kann einen Plan wählen; nichts wurde gelöscht.",
  statusFreeLimitReachedMember: "Das kostenlose Limit ist erreicht. Der Workspace-Inhaber kann einen Plan wählen, um weitere Anlagen hinzuzufügen.",
  statusFreeUntilMember: "Kostenlos bis {{date}}. Der Workspace-Inhaber wählt den Plan.",
  statusFreeFirstAsset_other: "Ihr Plan enthält {{count}} kostenlose Anlagen. Die Abrechnung beginnt, wenn Sie weitere hinzufügen.",
  statusFreeFirstAsset_one: "Ihr Plan enthält {{count}} kostenlose Anlage. Die Abrechnung beginnt mit der nächsten.",
  creditsNeeded_other: "Dafür sind {{count}} Credits nötig, Sie haben {{balance}}.",
  creditsNeeded_one: "Dafür ist {{count}} Credit nötig, Sie haben {{balance}}.",
  continueWithoutAi: "Ohne KI weiter",
  outOfCreditsOk: "OK",
  outOfCreditsNeutral: "Ihr Workspace hat keine KI-Credits mehr. Sie können ohne KI weiterarbeiten.",
  outOfCreditsMemberBodyUnnamed: "Sie können ohne KI weiterarbeiten. Bitten Sie den Workspace-Inhaber, Credits hinzuzufügen.",
  outOfCreditsMemberBody: "Sie können ohne KI weiterarbeiten. Bitten Sie {{owner}}, Credits hinzuzufügen.",
  outOfCreditsAdminBodyNoBuy: "Sie können ohne KI weiterarbeiten.",
  outOfCreditsAdminBody: "Sie können ohne KI weiterarbeiten oder ein Credit-Paket kaufen.",
title: "Abrechnung & Nutzung",
intro: "Überprüfen Sie den Status Ihres Abonnements, Ihre Credits und die nächsten Abrechnungsschritte.",
summaryIntro: "Ihr Plan, Ihre Credits und Ihre Abrechnung.",
outOfCreditsTitle: "Die KI-Credits sind aufgebraucht",
outOfCreditsBody: "KI-Aktionen benötigen Credits. Kaufen Sie ein Credit-Paket, um weiterzumachen, oder warten Sie auf Ihre monatlich enthaltenen Credits.",
outOfCreditsNotNow: "Nicht jetzt",
trialCapTitle: "Über Ihrem Testlimit",
creditPackPickerTitle: "Wählen Sie ein Credit-Paket",
creditPackPickerSubtitle: "Credits verfallen nie.",
buyCreditsCta: "Kaufen",
cancel: "Abbrechen",
kpiSectionTitle: "Nutzungsübersicht",
kpiSectionHint: "Wofür Sie abgerechnet werden und welche KI-Credits Sie haben.",
kpiAssetsTitle: "Abrechnungsfähige Anlagen",
kpiAssetsBody: "Aktive Anlagen, die in diesem Zyklus abgerechnet werden.",
kpiMonthlyPlanTitle: "Plan-Credits",
kpiMonthlyPlanBody: "Monatlich enthaltene Credits.",
kpiMonthlyPlanBodyUnlimited: "Monatliche Credits sind unbegrenzt.",
kpiPurchasedTitle: "Gekaufte Credits",
kpiPurchasedBody: "Noch verfügbare Auflade-Credits.",
kpiRemainingTitle: "Verbleibende Credits",
kpiRemainingBody: "Verbleibende enthaltene + gekaufte Credits.",
kpiRemainingBodyUnlimited: "Credits sind für diesen Workspace unbegrenzt.",
loading: "Abrechnungsdaten werden geladen...",
refresh: "Aktualisieren",
refreshing: "Wird aktualisiert...",
noAccount: "Für dieses Profil wurde kein Workspace-Konto gefunden.",
loadFailed: "Abrechnungsdaten konnten nicht geladen werden.",
billingDataMissing: "Abrechnungsdaten konnten nicht angezeigt werden. Versuchen Sie zu aktualisieren.",
errorTitle: "Abrechnungsdaten sind nicht verfügbar",
emptyTitle: "Für die Abrechnung ist ein Workspace erforderlich",
emptyBody: "Die Abrechnung gehört zu einem Workspace. Wechseln Sie in einen Workspace, um Plan, Credits und Rechnungswährung zu sehen.",
planTitle: "Abonnement",
unlimited: "Unbegrenzt",
subscriptionSummaryTitle: "Abonnementübersicht",
subscriptionSummarySubtitle: "Vom Anbieter bestätigter Status und Verlängerungszeitpunkt für diesen Workspace.",
managedOnWeb: "Änderungen an Plan und Credits sind in dieser App nicht verfügbar.",
statusFreeUntil: "Kostenlos bis {{date}}. Wählen Sie einen Plan, damit Ihr Workspace danach weiterläuft.",
internalEditionName: "Developer (interne Test-Edition)",
statusInternalEdition: "Interne Test-Edition: Alle Funktionen sind aktiv, nichts wird berechnet. Nur im Admin einstellbar.",
statusGranted: "Ihr Plan wird kostenlos bereitgestellt, ohne Enddatum.",
statusGrantedUntil: "Ihr Plan wird bis {{date}} kostenlos bereitgestellt. Wählen Sie vorher einen Plan, damit Ihr Workspace weiterläuft.",
statusFreeFirstAsset: "Noch keine Kosten. Die Abrechnung beginnt, wenn Sie mehr Anlagen hinzufügen, als Ihr Plan kostenlos enthält.",
statusFreeLimitReached: "Ihr kostenloses Limit ist erreicht. Wählen Sie einen Plan, um weitere Anlagen hinzuzufügen.",
statusFreePeriodEnded: "Ihre kostenlose Zeit ist abgelaufen und Ihr Workspace ist schreibgeschützt. Wählen Sie einen Plan, um weiterzuarbeiten; nichts wurde gelöscht.",
statusActive: "Ihr Abonnement ist aktiv.",
statusActiveRenews: "Ihr Abonnement ist aktiv und verlängert sich am {{date}}.",
statusActiveEnds: "Ihr Abonnement ist gekündigt und endet am {{date}}. Bis dahin behalten Sie Ihren Tarif.",
statusBilledByStore: "Ihr Abonnement wird über den App-Store abgerechnet. Verwalten Sie es dort.",
changePlanHint: "Wechseln Sie zu einem anderen Plan; der Wechsel wird vor der Abbuchung bestätigt.",
cancelSubscription: "Abonnement kündigen",
cancelSubscriptionHint: "Ihr Tarif bleibt bis zum Ende des bezahlten Zeitraums bestehen; es wird nichts mehr abgebucht.",
resumeSubscription: "Abonnement fortsetzen",
resumeSubscriptionHint: "Behalten Sie Ihren Tarif; er verlängert sich wie bisher.",
cancelSubscriptionConfirmTitle: "Abonnement kündigen?",
cancelSubscriptionConfirmBody: "Sie behalten {{plan}} bis zum {{date}}; es wird nichts mehr abgebucht. Bis dahin können Sie jederzeit fortsetzen.",
cancelSubscriptionConfirmBodyNoDate: "Sie behalten {{plan}} bis zum Ende des aktuellen Zeitraums; es wird nichts mehr abgebucht. Bis dahin können Sie jederzeit fortsetzen.",
cancelSubscriptionKeep: "Tarif behalten",
cancelSubscriptionConfirm: "Abonnement kündigen",
cancelSubscriptionError: "Ihr Abonnement konnte nicht geändert werden.",
planReference: "Abrechnung {{plan}}",
paymentStatusLabel: "Zahlungsstatus",
paymentStatusFreeDetail: "Noch keine Kosten. Die Abrechnung beginnt, wenn Sie mehr Anlagen hinzufügen, als Ihr Plan kostenlos enthält.",
paymentStatusGrantedDetail: "Kostenlos bereitgestellt. Es wird nichts abgerechnet.",
paymentStatusSubscriptionRequiredDetail: "Kostenloses Limit erreicht. Starten Sie ein Abonnement, um weitere aktive Anlagen hinzuzufügen.",
paymentStatusStripeDetail: "Die Abrechnung ist für diesen Workspace aktiv.",
paymentStatusPastDueDetail: "Die Zahlung ist überfällig. Klären Sie dies im Abrechnungsportal, um eine Serviceunterbrechung zu vermeiden.",
paymentStatusPausedDetail: "Das Abonnement ist pausiert. Setzen Sie die Abrechnung fort, bevor Sie weitere aktive Anlagen hinzufügen.",
paymentStatusInactiveDetail: "Kein aktiver Zahlungseinzug. Starten oder reaktivieren Sie ein Abonnement, um die Abrechnung fortzusetzen.",
paymentStatusInternalDetail: "Die Abrechnung ist für diesen Workspace noch nicht vollständig eingerichtet; dies ist der letzte bekannte Stand.",
renewalDateLabel: "Verlängerungsdatum",
renewalKnownDetail: "Basierend auf dem zuletzt synchronisierten Ende des Abonnementzeitraums.",
renewalUnknownDetail: "Der Verlängerungszeitpunkt ist für diesen Workspace noch nicht verfügbar.",
lastTrueUpLabel: "Anlagen zuletzt gezählt",
trueUpKnownDetail: "Wann Ihre aktiven Anlagen zuletzt für die Abrechnung gezählt wurden.",
trueUpUnknownDetail: "Ihre Anlagen wurden noch nicht für die Abrechnung gezählt.",
presentmentCurrencyLabel: "Rechnungswährung",
presentmentCurrencyBadge: "Abrechnung in {{currency}}",
currencyUnknown: "Unbekannt",
currencyPresentmentNote: "Preise werden in {{currency}} festgelegt. Ihre Rechnung kann Ihre Landeswährung zeigen.",
currencyCatalogOnlyNote: "Preise und Rechnungen sind in {{currency}}.",
editionTitle: "Ihr Plan",
editionSubtitle: "Ihr Plan legt fest, welche Funktionen verfügbar sind. Anlagen und KI-Credits werden separat abgerechnet.",
monthlyAmountTitle: "Geschätzter monatlicher Betrag",
monthlyAmountSubtitle: "Ihre Rechnung zeigt den endgültigen Betrag.",
amountFinal: "Endgültiger Betrag",
amountEstimated: "Geschätzter Betrag",
amountUnavailable: "Betrag nicht verfügbar",
amountFinalExplanation: "Aus der zuletzt abgerechneten Rechnung.",
amountEstimatedPresentmentExplanation: "Eine Schätzung. Ihre Rechnung zeigt den endgültigen Betrag, gegebenenfalls in Ihrer Landeswährung.",
amountEstimatedCatalogExplanation: "Eine Schätzung in {{currency}}. Ihre Rechnung zeigt den endgültigen Betrag.",
amountUnavailableExplanation: "Ein verlässlicher kundenseitiger Betrag ist noch nicht verfügbar.",
creditsAndAssetsTitle: "Credits und abrechnungsfähige Anlagen",
creditsAndAssetsSubtitle: "Betriebliche Salden für Nutzung und Limits.",
billableAssetsMetric: "Aktive abrechnungsfähige Anlagen",
includedMonthlyMetric: "Enthaltene monatliche Credits",
purchasedCreditsMetric: "Gekaufte Credits",
totalRemainingCreditsMetric: "Verbleibende Credits gesamt",
pricingExplanationTitle: "Preisdetails",
pricingExplanationSubtitle: "Aktuelle Abrechnungsstufen aus dem Katalog.",
pricingSummaryKnown: "Gestaffelte Preise für {{assetCount}} aktive abrechnungsfähige Anlagen, ausgewiesen in {{currency}}.",
pricingSummaryUnknown: "Aus dem Abrechnungskatalog liegen noch keine strukturierten Preisstufen vor, daher kann die App keine verlässliche Preiserklärung Zeile für Zeile anzeigen.",
pricingBandOpenEnded: "{{min}}+ Anlagen",
pricingBandRange: "{{min}} bis {{max}} Anlagen",
pricingBandLabel: "{{label}}",
pricingBandUnknown: "Tarif nicht verfügbar",
pricingBandEmpty: "Für dieses Abrechnungsmodell sind noch keine Preisstufen konfiguriert.",
catalogReferenceNote: "Referenzwährung des Katalogs: {{currency}}.",
startSubscription: "Abonnement starten",
startSubscriptionHint: "Starten Sie ein Abo, um mehr Anlagen hinzuzufügen, als Ihr Plan kostenlos enthält.",
startSubscriptionAdminOnly: "Nur der Workspace-Inhaber kann das Abo starten.",
startSubscriptionStripeOff: "Kaufen ist gerade nicht möglich.",
startSubscriptionUnavailable: "Dieser Workspace kann aus dem aktuellen Abrechnungsstatus kein neues Abonnement starten.",
manageSubscriptionHint: "Öffnen Sie das Abrechnungsportal, um Ihr Abonnement oder Ihre Zahlungsmethode zu verwalten.",
manageBillingAdminOnly: "Nur der Workspace-Inhaber kann die Abrechnung verwalten.",
manageBillingUnavailable: "Der Zugriff auf das Abrechnungsportal ist für diesen Workspace noch nicht verfügbar.",
buyMoreCredits: "Credits kaufen",
buyCreditsHint: "Kaufen Sie ein Credit-Paket. Einmalige, sichere Zahlung.",
buyCreditsAdminOnly: "Nur der Workspace-Inhaber kann Credits kaufen.",
buyCreditsStripeOff: "Kaufen ist gerade nicht möglich.",
buyCreditsUnavailable: "Für Credit-Pakete ist noch kein Preis konfiguriert.",
buyCreditsPriceHint: "Referenzpreis im Katalog: {{price}}.",
priceUnavailable: "Preis nicht verfügbar",
activityTitle: "Letzte Credit-Aktivität",
activitySubtitle: "Neueste Credit-Bewegungen (Vorschau).",
subscriptionDetailsTitle: "Abonnementdetails",
subscriptionDetailsSubtitle: "Betriebliche Zeitangaben und Synchronisierungsdetails.",
currencyDetailsTitle: "Währungsdetails",
currencyDetailsSubtitle: "Verhalten von Anzeige- und Katalogwährung.",
showDetails: "Details anzeigen",
hideDetails: "Details ausblenden",
ledgerEmpty: "Noch keine Credit-Aktivität.",
linkAudit: "KI- & Automatisierungsprotokoll öffnen",
manageStripeBilling: "Abonnement verwalten",
stripeCheckoutError: "Die Zahlung konnte nicht geöffnet werden. Versuchen Sie es erneut.",
stripePortalError: "Die Abrechnungsverwaltung konnte nicht geöffnet werden. Versuchen Sie es erneut.",
stripeConfigOff: "Der Stripe-Checkout ist deaktiviert. Setzen Sie in der `.env`-Datei im Projektstammverzeichnis EXPO_PUBLIC_STRIPE_BILLING_ENABLED=true und fügen Sie dann EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION und/oder EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 hinzu (jeweils eine Stripe-price_...-ID). Starten Sie Expo mit `npx expo start --clear` neu.",
stripeConfigNoPrices: "Stripe ist aktiviert, es wurden jedoch keine gültigen Price-IDs gefunden. Verwenden Sie Stripe-Price-IDs, die mit `price_` beginnen (nicht `prod_`). Setzen Sie EXPO_PUBLIC_STRIPE_PRICE_ID_ASSET_SUBSCRIPTION und/oder EXPO_PUBLIC_STRIPE_PRICE_ID_CREDIT_PACK_100 in `.env` und starten Sie Expo anschließend neu.",
confirmationConfirmedTitle: "Kauf abgeschlossen",
confirmationCancelledTitle: "Bezahlvorgang abgebrochen",
confirmationPendingTitle: "Ihr Kauf wird abgeschlossen",
confirmationConfirmedBody: "Fertig. Ihr Plan und Ihre Credits unten sind aktuell.",
confirmationCancelledBody: "Es wurde keine Abrechnungsänderung angewendet. Ihr bisheriger Tarif und Ihre Credits bleiben unverändert.",
confirmationPendingBody: "Zahlung erhalten. Ihr Plan und Ihre Credits werden in wenigen Sekunden aktualisiert. Tippen Sie auf Aktualisieren, falls nicht.",
trialCapBody_one: "Ihre Testphase erlaubt {{max}}. Sie haben {{billable}} aktive Anlagen, daher wird {{count}} Anlage berechnet, sobald Ihre Testphase in einen bezahlten Plan übergeht.",
trialCapBody_other: "Ihre Testphase erlaubt {{max}}. Sie haben {{billable}} aktive Anlagen, daher werden {{count}} Anlagen berechnet, sobald Ihre Testphase in einen bezahlten Plan übergeht.",
trialCapBodyDated_one: "Ihre Testphase erlaubt {{max}}. Sie haben {{billable}} aktive Anlagen, daher wird {{count}} Anlage berechnet, wenn Ihre Testphase am {{trialEnd}} endet.",
trialCapBodyDated_other: "Ihre Testphase erlaubt {{max}}. Sie haben {{billable}} aktive Anlagen, daher werden {{count}} Anlagen berechnet, wenn Ihre Testphase am {{trialEnd}} endet.",
forecastTitle: "KI-Credit-Verbrauch und Prognose",
forecastSubtitle: "Wie Ihre Credits in den letzten 30 Tagen genutzt wurden und wie lange sie noch reichen.",
consumedLast30Days: "Verbraucht in 30 Tagen",
averageDailyUse: "Durchschnitt pro Tag",
estimatedRunway: "Credits reichen etwa",
runwayNotLimited: "Unbegrenzt",
runwayDays_one: "{{count}} Tag",
runwayDays_other: "{{count}} Tage",
ledgerReconciled: "Guthaben ist aktuell",
ledgerPartial: "Guthaben wird noch aktualisiert",
contactAdminTitle: "Die Abrechnung verwaltet der Workspace-Inhaber",
contactAdminTitleNamed: "Tarif und Credits verwaltet der Inhaber von {{workspace}}",
contactAdminSubtitle: "Hier sehen Sie die Nutzung. Nur der Inhaber kann den Plan ändern oder Credits kaufen.",
viewWorkspaceAdmins: "Arbeitsbereich-Admins anzeigen",
detailsTitle: "Abrechnungsdetails",
detailsSubtitle: "Abonnement, Preise und Währung.",
chargingPolicyTitle: "So werden KI-Credits berechnet",
chargingPolicySubtitle: "Wofür Sie zahlen, wofür nicht und was passiert, wenn etwas fehlschlägt.",
chargingSuccess: "Funktionierende KI wird einmal berechnet, nachdem Sie das Ergebnis erhalten haben.",
chargingFailure: "Fehlgeschlagene KI-Ausgaben werden nicht berechnet, manuelle Arbeit bleibt möglich.",
chargingRetry: "Schlägt das Verbuchen fehl, versuchen wir es einmal erneut und berechnen nie doppelt.",
packForecastNoPattern: "Die Prognoseauswirkung erscheint, sobald Verbrauch erfasst wurde.",
packForecastDays_one: "Etwa {{count}} zusätzlicher Tag bei aktuellem Verbrauch",
packForecastDays_other: "Etwa {{count}} zusätzliche Tage bei aktuellem Verbrauch",
},
};
